export default "__VITE_ASSET__ByxeQh5Y__"